module.exports = __webpack_public_path__ + "img/pic_310613_2.a64f2ba6.jpg";